import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { map, get, sortBy, filter, includes, isEmpty } from "lodash";
import Grid from "@material-ui/core/Grid";
import { I18n } from "@aws-amplify/core";

import FormSection from "../../Common/FormSection";
import MultipleFormSection from "./MultipleFormSection";
import { getAttributeValue, getAttributeValues } from "../../../utils/profile";
import { getAttributeName } from "../../../utils/attributes";
import ContainerService from "../../../utils/containerISO6346";
import { LANGUAGES } from "../../../constants/common";

const styles = {
  sectionCol: {
    padding: "12px 24px 0",
    minWidth: "248px",
    maxWidth: "308px",
  },
};

const ContainerForm = (props) => {
  const {
    classes,
    section,
    data,
    lov,
    handleChange,
    validForm,
    errors,
    language,
    profileAttributes,
    profileValidationRules
  } = props;

  const validateAttribute = [291, 292]

  const containerSATC = getAttributeValue(data, 292)
  const [typeAndDimentions, setTypeAndDimentions] = useState({})
  const [unit, setUnit] = useState("m")

  // update the units based on profileValidationRules for containerSATC value
  useEffect(() => {
    const satcValidation = get(profileValidationRules, ["satcValidation"]);
    const containerIdValidation = get(profileValidationRules, ["containerIdValidation"]);
    if (satcValidation?.unit) setUnit(satcValidation.unit)
    else setUnit("m")
    if (!isEmpty(containerIdValidation)) {
      handleChange(301, 0, containerIdValidation?.enabled || false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileValidationRules])

  // Depending on containerSATC value, get and show typeAndDimentions
  useEffect(() => {
    if (containerSATC && containerSATC?.length > 0)
      setTypeAndDimentions(ContainerService.getTypeAndDimentions(containerSATC))
    else setTypeAndDimentions({})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerSATC])

  const isValid = (id) => {
    if (id === 291 && !getAttributeValue(data, 291)) {
      return true
    }
    if (getAttributeValue(data, 18) && getAttributeValue(data, 54) && data.sys_tag_id && getAttributeValue(data, 89) && getAttributeValue(data, 50)) {
      return true
    } else {
      validForm.form = false
    }
    if (validForm && validForm[id]) {
      return true;
    }
    return false;
  };

  const fromattingContainerID = (id) => {

    let containerID = getAttributeValue(data, id)
    if (!getAttributeValue(data, 301)) return containerID
    if (containerID?.length > 4) containerID = containerID.slice(0, 4) + " " + containerID.slice(4)
    if (containerID?.length > 11) containerID = containerID.slice(0, 11) + " " + containerID.slice(11)
    return containerID
  }
  const setComponentFormValue = (name, index, value, subValue) => {

    if (name === 291) {
      value = value.split(' ').join('')
      if (!value || value.length <= 11) {
        handleChange(name, index, value, subValue);
      }
    } else {
      handleChange(name, index, value, subValue)
    }
  }

  if (section === "main") {
    const attributes = sortBy(
      filter(
        profileAttributes,
        (attr) => get(attr, ["active"]) && get(attr, ["app_display_main_page"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );
    const attr301 = attributes.find(attr => attr.id == 301)
    return (
      <>
        <Grid container style={{ marginTop: "-14px" }}>
          <Grid
            item
            xs={3}
            className={classes.sectionCol}
            style={{ paddingTop: "29px" }}
          >
            <Grid container direction="column">
              <FormSection
                formValue={[getAttributeValue(data, 18)]}
                setFormValue={handleChange}
                title2={getAttributeName(18)}
                id={18}
                options={{ required: true, redBorder: !isValid(18) }}
              />
              <FormSection
                formValue={[getAttributeValue(data, 54)]}
                setFormValue={handleChange}
                title2={getAttributeName(54)}
                id={54}
                type="select"
                options={{
                  required: true,
                  redBorder: !isValid(54),
                  options: lov[54].map((t) => ({
                    id: t.id,
                    name: t["name_" + language],
                  })),
                }}
              />
              <FormSection
                formValue={[data.sys_tag_id]}
                setFormValue={handleChange}
                title="tag"
                id="sys_tag_id"
                type="select"
                options={{
                  required: true,
                  redBorder: !isValid("sys_tag_id"),
                  comboBox: true,
                  options:
                    lov.tag &&
                    lov.tag.map((t) => ({
                      id: t.id,
                      name: t["name_" + language],
                    })),
                }}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={3}
            className={classes.sectionCol}
            style={{ paddingTop: "29px" }}
          >
            <Grid container direction="column">
              <FormSection
                formValue={[getAttributeValue(data, 89)]}
                setFormValue={handleChange}
                title2={getAttributeName(89)}
                id={89}
                type="select"
                options={{
                  required: true,
                  redBorder: !isValid(89),
                  comboBox: true,
                  options: map(
                    sortBy(get(lov, [89]), (t) => t[`name_${language}`]),
                    (t) => ({
                      id: t.id,
                      name: t[`name_${language}`],
                    })
                  ),
                }}
              />
              <FormSection
                formValue={[getAttributeValue(data, 46)]}
                setFormValue={handleChange}
                title2={getAttributeName(46)}
                id={46}
              />
            </Grid>
          </Grid>
          <Grid item xs>
            <Grid container direction="column">
              <Grid item>
                <Grid container>
                  <Grid
                    item
                    xs
                    className={classes.sectionCol}
                    style={{
                      paddingTop: "29px",
                      maxWidth: "unset",
                      minWidth: "unset",
                    }}
                  >
                    <MultipleFormSection
                      id={50}
                      typeId={135}
                      title2={getAttributeName(50)}
                      data={getAttributeValues(data, 50)}
                      setFormValue={handleChange}
                      lov={lov}
                      language={language}
                      errorMsg={errors[50]}
                      required={true}
                      checkbox={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container style={{ alignItems: 'flex-end' }}>
          {map(attributes, (attr) => {
            return [18, 54, 50, 46, 89, 51, 52, 301].includes(
              attr.id
            ) ? null : (
              <Grid
                item
                key={attr.id}
                xs={3}
                style={{
                  paddingBottom: "0",
                  padding: "10px 24px 0 24px",
                  minWidth: "248px",
                  maxWidth: "308px",
                }}
              >
                <Grid container direction="column">
                  {attr.id === 291 && (
                    <FormSection
                      formValue={[getAttributeValue(data, 301)]}
                      setFormValue={setComponentFormValue}
                      attribute={attr301}
                      id={301}
                      type={
                        attr301.data_type
                      }
                    />
                  )}

                  <FormSection
                    formValue={[attr.id == 291 ? fromattingContainerID(attr.id) : getAttributeValue(data, attr.id)]}
                    setFormValue={setComponentFormValue}
                    onBlurHandler={(event) => {
                      if (attr.id === 291) {
                        const containerId = getAttributeValue(data, attr.id);
                        if (containerId && containerId.length === 10) {
                          setComponentFormValue(
                            291,
                            0,
                            `${containerId}${ContainerService.calculateCheckDigit(containerId)}`
                          );
                        }
                      }
                    }}
                    attribute={attr}
                    id={attr.id}
                    type={
                      includes(["radiobutton", "lov(picker)"], attr.data_type)
                        ? "select"
                        : attr.data_type === "boolean"
                          ? "boolean"
                          : "input"
                    }
                    options={{
                      msgValue:
                        attr.id == 291 &&
                          getAttributeValue(data, 301) &&
                          get(profileValidationRules, [
                            "containerIdValidation",
                            "suffix",
                            language,
                          ])
                          ? get(profileValidationRules, [
                            "containerIdValidation",
                            "suffix",
                            language,
                          ])
                          : "",
                      redBorder: validateAttribute.includes(attr.id)
                        ? errors[attr.id]?.length > 0
                        : attr.required && !isValid(attr.id),
                      errorMsg: validateAttribute.includes(attr.id)
                        ? errors[attr.id]
                        : "",
                      comboBox: attr.id === 89,
                      options: includes(
                        ["radiobutton", "lov(picker)"],
                        attr.data_type
                      )
                        ? map(
                          sortBy(lov[attr.id], (t) => t[`name_${language}`]),
                          (t) => ({
                            id: t.id,
                            name: t[`name_${language}`],
                          })
                        )
                        : null,
                    }}
                  />
                </Grid>
              </Grid>
            );
          })}
        </Grid>
        {!isEmpty(typeAndDimentions) && (
          <Grid container>
            <Grid
              item
              xs={3}
              style={{
                paddingBottom: "0",
                padding: "10px 24px 0 24px",
                minWidth: "248px",
                maxWidth: "308px",
              }}
              direction="column"
            >
              <FormSection
                permission={true}
                formValue={[
                  typeAndDimentions["dimentions"]["height"]
                    ? typeAndDimentions["dimentions"]["height"][unit] + ' ' + get(profileValidationRules, ["satcValidation", "unit"])
                    : "",
                ]}
                setFormValue={() => { }}
                title2={"Height"}
                id={1000}
                options={{
                  redBorder: !(
                    typeAndDimentions["dimentions"]["height"] &&
                    typeAndDimentions["dimentions"]["height"][unit]
                  ),
                  errorMsg: !(
                    typeAndDimentions["dimentions"]["height"] &&
                    typeAndDimentions["dimentions"]["height"][unit]
                  )
                    ? I18n.get("Invalid_Height")
                    : "",
                }}
              />
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                paddingBottom: "0",
                padding: "10px 24px 0 24px",
                minWidth: "248px",
                maxWidth: "308px",
              }}
              direction="column"
            >
              <FormSection permission={true}
                formValue={[
                  typeAndDimentions["dimentions"]["length"]
                    ? typeAndDimentions["dimentions"]["length"][unit] + ' ' + get(profileValidationRules, ["satcValidation", "unit"])
                    : "",
                ]}
                setFormValue={() => { }}
                title2={"Length"}
                id={1000}
                options={{
                  redBorder: !(
                    typeAndDimentions["dimentions"]["length"] &&
                    typeAndDimentions["dimentions"]["length"][unit]
                  ),
                  errorMsg: !(
                    typeAndDimentions["dimentions"]["length"] &&
                    typeAndDimentions["dimentions"]["length"][unit]
                  )
                    ? I18n.get("Invalid_Length")
                    : "",
                }}
              />
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                paddingBottom: "0",
                padding: "10px 24px 0 24px",
                minWidth: "248px",
                maxWidth: "308px",
              }}
              direction="column"
            >
              <FormSection permission={true}
                formValue={[
                  typeAndDimentions["dimentions"]["width"]
                    ? typeAndDimentions["dimentions"]["width"][unit] + ' ' + get(profileValidationRules, ["satcValidation", "unit"])
                    : "",
                ]}
                setFormValue={() => { }}
                title2={"Width"}
                id={1000}
                options={{
                  redBorder: !(
                    typeAndDimentions["dimentions"]["width"] &&
                    typeAndDimentions["dimentions"]["width"][unit]
                  ),
                  errorMsg: !(
                    typeAndDimentions["dimentions"]["width"] &&
                    typeAndDimentions["dimentions"]["width"][unit]
                  )
                    ? I18n.get("Invalid_Width")
                    : "",
                }}
              />
            </Grid>

            <Grid
              item
              xs={3}
              style={{
                paddingBottom: "0",
                padding: "10px 24px 0 24px",
                minWidth: "248px",
                maxWidth: "308px",
              }}
              direction="column"
            >
              <FormSection permission={true}
                formValue={[
                  typeAndDimentions["type"]["valid"]
                    ? typeAndDimentions["type"]["desc"]
                    : "",
                ]}
                setFormValue={() => { }}
                title2={"Description"}
                id={1000}
                options={{
                  redBorder: !typeAndDimentions["type"]["valid"],
                  errorMsg: !typeAndDimentions["type"]["valid"]
                    ? I18n.get("Invalid_Desc")
                    : "",
                }}
              />
            </Grid>

            <Grid
              item
              xs={3}
              style={{
                paddingBottom: "0",
                padding: "10px 24px 0 24px",
                minWidth: "248px",
                maxWidth: "308px",
              }}
              direction="column"
            >
              <FormSection permission={true}
                formValue={[
                  typeAndDimentions["type"]["valid"]
                    ? typeAndDimentions["type"]["category"]
                    : "",
                ]}
                setFormValue={() => { }}
                title2={"Category"}
                id={1000}
                options={{
                  redBorder: !typeAndDimentions["type"]["valid"],
                  errorMsg: !typeAndDimentions["type"]["valid"]
                    ? I18n.get("Invalid_Category")
                    : "",
                }}
              />
            </Grid>
          </Grid>
        )}
      </>
    );
  }

  if (section === "secondary") {
    const attributes = sortBy(
      filter(
        profileAttributes,
        (attr) => get(attr, ["active"]) && !get(attr, ["app_display_main_page"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );
    return (
      <>
        <Grid container>
          {map(attributes, (attr) => (
            <Grid
              item
              key={attr.id}
              xs={3}
              style={{
                paddingBottom: "0",
                padding: "10px 24px 0 24px",
                minWidth: "248px",
                maxWidth: "308px",
              }}
            >
              <Grid container direction="column">
                <FormSection
                  formValue={[getAttributeValue(data, attr.id)]}
                  setFormValue={handleChange}
                  attribute={attr}
                  id={attr.id}
                  type={
                    includes(["radiobutton", "lov(picker)"], attr.data_type)
                      ? "select"
                      : attr.data_type === "boolean"
                        ? "boolean"
                        : "input"
                  }
                  options={{
                    redBorder: attr.required && !isValid(attr.id),
                    comboBox: attr.id === 89,
                    options: includes(
                      ["radiobutton", "lov(picker)"],
                      attr.data_type
                    )
                      ? map(
                        sortBy(lov[attr.id], (t) => t[`name_${language}`]),
                        (t) => ({
                          id: t.id,
                          name: t[`name_${language}`],
                        })
                      )
                      : null,
                  }}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </>
    );
  }

  return null;
};

ContainerForm.propTypes = {
  profileType: PropTypes.oneOf([4]).isRequired,
  section: PropTypes.oneOf(["main", "secondary"]).isRequired,
  data: PropTypes.object.isRequired,
  lov: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  validForm: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  language: PropTypes.oneOf(LANGUAGES),
  profileValidationRules: PropTypes.object.isRequired
};

export default withStyles(styles)(ContainerForm);
